import { Space, Table } from "antd";

import { GrView } from "react-icons/gr";

function TaskDataTable(props: any) {
  const columns = [
    {
      dataIndex: "name",
      title: "Name",
    },
    {
      dataIndex: "username",
      title: "username",
    },
    {
      dataIndex: "password",
      title: "password",
    },
    {
      dataIndex: "companyName",
      title: "companyName",
    },
    {
      dataIndex: "address",
      title: "address",
    },
    {
      dataIndex: "client_phone",
      title: "client_phone",
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={Array.isArray(props?.dataSource) ? props?.dataSource : []}
        pagination={props?.pagination}
      />
    </div>
  );
}

export default TaskDataTable;
